import { store } from '@betacrew/jars-flux'
export const componentKey = "CHANGE_PASSWORD";

const { actions } = store.reducerManager.add({
	key: componentKey,
	addedReducers: {
		setNewPasswordValidations: (state, action) => {
			state.newPasswordValidations = action.payload;
		},
		setLoadingState: (state, action) => {
			state.loadingState = action.payload;
		},
		setChangePasswordSuccess: (state, action) => {
			state.changePasswordSuccess = action.payload;
		}
	},
	initialReducerState: {
		newPasswordValidations: [],
		loadingState: false,
		changePasswordSuccess: false,
	}
});
export const { setNewPasswordValidations, setLoadingState, setChangePasswordSuccess } = actions;